/** Planes comerciales para alta manual desde el panel de plataforma. */

export const PLANES_CLINICA = [
  { slug: 'clinica-solo' as const, nombre: 'Clínica · Solo', precio: 99 },
  { slug: 'clinica' as const, nombre: 'Clínica', precio: 299 },
  { slug: 'clinica-plus' as const, nombre: 'Clínica · Plus', precio: 499 },
];

export const PLANES_HOSPITAL = [
  { slug: 'hospital-starter' as const, nombre: 'Hospital · Starter', precio: 599 },
  { slug: 'hospital-pro' as const, nombre: 'Hospital · Pro', precio: 2499 },
  { slug: 'hospital-enterprise' as const, nombre: 'Hospital · Enterprise', precio: 5999 },
];

export const TIPOS_CLINICA = [
  { value: 'clinica-medica', label: 'Médica' },
  { value: 'clinica-odontologica', label: 'Odontológica' },
  { value: 'clinica-veterinaria', label: 'Veterinaria' },
  { value: 'clinica-nutricion', label: 'Nutrición' },
  { value: 'clinica-psicologia', label: 'Psicología' },
  { value: 'clinica-estetica', label: 'Estética' },
  { value: 'clinica-optica', label: 'Óptica' },
  { value: 'clinica-fisioterapia', label: 'Fisioterapia' },
] as const;
